import React from 'react'
import WisFilterIcon from "../svg/WisFilterIcon"

export default function Tag(props) {
	const displayIcon = props.displayIcon;
	const classname = props.classname;

	return (
		<button
			key={props.index}
			onClick={props.onclick}
			className={classname ? `tag tag--filterBar ${classname}` : "tag tag--filterBar" }
		>
				<p className="tag__text">{props.tagText}</p>
				{displayIcon && <WisFilterIcon/>}
		</button>
	)
}
